import {
  IBonusRebatesStatusToTagMap as IStatusToTagMap,
} from '@fleet-cards/overview/bonus-rebates-component/bonus-rebates.const';

export const BONUS_REBATES_OFFER_ID = 'bonus_rebates';

export enum OFFER_BANNER_TYPES {
  NEW = 'new',
  NEEDS_ATTENTION = 'needs_attention',
  UPSELL = 'upsell',
}

export enum BANNER_ACKNOWLEDGEMENT_TYPES {
  OFFER_VIEWED = 'offer_viewed',
  NEW_OFFER_BANNER_DISMISSED = 'new_offer_banner_dismissed',
  NEEDS_ATTENTION_OFFER_BANNER_DISMISSED = 'needs_attention_offer_banner_dismissed',
  NEEDS_ATTENTION_OFFER_BANNER_VIEWED = 'needs_attention_offer_banner_dismissed',
  APPLY_NOW_OFFER_BANNER_DISMISSED = 'apply_now_offer_banner_dismissed',
  APPLY_NOW_OFFER_BANNER_CLICKED = 'apply_now_offer_banner_clicked',
}

export type OfferBannerType = OFFER_BANNER_TYPES.NEW | OFFER_BANNER_TYPES.NEEDS_ATTENTION | OFFER_BANNER_TYPES.UPSELL;

export enum OFFER_TYPES {
  FUEL_BASED = 'fuel_based',
  SPEND_BASED = 'spend_based',
  FLAT_OFFER = 'flat_offer',
}

export type OfferType = OFFER_TYPES.FUEL_BASED | OFFER_TYPES.SPEND_BASED | OFFER_TYPES.FLAT_OFFER;

export enum PROMO_OFFERS_STATUSES {
  OFF_TRACK = 'off_track',
  ON_TRACK = 'on_track',
  GETTING_STARTED = 'getting_started',
  CLOSE_TO_FINISH = 'on_track_close_to_finish',
  THRESHOLD_CROSSED = 'threshold_crossed',
  TARGET_UNMET = 'target_unmet',
  EXPIRED = 'expired',
  ACTIVE = 'active',
}

export const PROMO_OFFERS_STATUS_TAG_MAP: Record<PROMO_OFFERS_STATUSES, IStatusToTagMap> = {
  [PROMO_OFFERS_STATUSES.OFF_TRACK]: {
    text: $localize`Off Track`,
    className: 'caution',
    shouldShow: true,
  },
  [PROMO_OFFERS_STATUSES.GETTING_STARTED]: {
    className: 'accent',
    shouldShow: false,
  },
  [PROMO_OFFERS_STATUSES.ON_TRACK]: {
    text: $localize`On Track`,
    className: 'accent',
    shouldShow: true,
  },
  [PROMO_OFFERS_STATUSES.CLOSE_TO_FINISH]: {
    text: $localize`On Track`,
    className: 'accent',
    shouldShow: true,
  },
  [PROMO_OFFERS_STATUSES.THRESHOLD_CROSSED]: {
    className: 'accent',
    shouldShow: false,
  },
  [PROMO_OFFERS_STATUSES.TARGET_UNMET]: {
    text: $localize`EXPIRED`,
    className: 'neutral',
    shouldShow: true,
  },
  [PROMO_OFFERS_STATUSES.EXPIRED]: {
    text: $localize`EXPIRED`,
    className: 'neutral',
    shouldShow: true,
  },
  [PROMO_OFFERS_STATUSES.ACTIVE]: {
    className: 'neutral',
    shouldShow: false,
  },
};